export const downloadPdf = async (setFetching: (state: boolean) => void, templateUrl?: string, skillCode?: string) => {
  setFetching(true);
  try {
    const pdf = await fetch(templateUrl || '');
    const blob = await pdf.blob();
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${skillCode}_practice_problems.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch {
    console.log('Error downloading pdf');
  } finally {
    setFetching(false);
  }
};
